import React from "react";
import pic1 from "../images/hackerrank.png";
import pic2 from "../images/leetcode.png";
import pic3 from "../images/leetcode db.png";
import pic4 from "../images/tailwind.png";
import pic5 from "../images/html.png";
import pic6 from "../images/css.png";

const Ratings = () => {
  return (
    <>
      <div id="ratings" className="section-padding">
        <h1 className="text-black text-4xl font-bold text-center mt-5">
          Stats
        </h1>
        <section>
          <section className="ml-8 mr-8 lg:ml-32 mb-5 lg:mr-32 mt-5 border border-solid rounded-xl shadow-lg	border-violet-100	">
            <div className="grid grid-cols-1 p-4">
              <div className="bg-blue-200		 m-4 rounded-md	p-4">
              <div className="text-xl lg:text-4xl font-bold text-sky-900  text-center underline underline-offset-2	">
                    Hackerrank
                  </div>
                <div className="lg:flex justify-start content-start">
                  <div className="lg:columns-2">
                    <img src={pic1} className="mx-auto w-24 lg:w-64" alt="" />
                  </div>
                  
                  <div className="mt-4">
                    <div className="bg-indigo-200	lg:m-4 rounded-md	p-2 hover:bg-slate-300">
                      <h2 className="text-center text-sm">
                        Problem Solving : <span> &#9733; &#9733; &#9733;</span>
                      </h2>
                      <h2 className="text-center text-sm">
                        30 days of code:&#9733; &#9733; &#9733;&#9733; &#9733;{" "}
                      </h2>
                      <h2 className="text-center text-sm">
                        Java : &#9733; &#9733; &#9733;&#9733; &#9733;{" "}
                      </h2>
                      <h2 className="text-center text-sm">
                        Python : &#9733; &#9733; &#9733;{" "}
                      </h2>
                      <h2 className="text-center text-sm">
                        C++ : &#9733; &#9733; &#9733;{" "}
                      </h2>
                      <h2 className="text-center text-sm">
                        C : &#9733; &#9733;{" "}
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-center">
                  <a
                    href="https://www.hackerrank.com/btech15007_20?hr_r=1"
                    target="blank"
                  >
                    <button class="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
                      Profile
                    </button>
                  </a>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-1 p-4">
              <div className="bg-blue-200 m-4 rounded-md	p-4">
              <div className="text-4xl font-bold text-sky-900  text-center underline underline-offset-2	">
                    Leetcode
                  </div>
                <div className="lg:flex justify-start content-start">
                  <div className="mt-2 lg:columns-2">
                    <img src={pic2} className="mx-auto sm-w-24 md:w-36 lg:w-96" alt="" />
                  </div>
                  
                  <div className="mt-4">
                    <div className="bg-indigo-200	 lg:m-4 rounded-md	p-2 hover:bg-slate-300">
                      {/* <h2 className="text-center text-sm">
                        Contest ratings : 1335
                      </h2> */}
                      <img src={pic3} alt="" />
                    </div>
                  </div>
                </div>
                <div className="flex flex-col items-center">
                  <a href="https://leetcode.com/fatma-sia/" target="blank">
                    <button class="bg-transparent hover:bg-blue-500 text-blue-700 font-semibold hover:text-white py-2 px-4 border border-blue-500 hover:border-transparent rounded">
                      Profile
                    </button>
                  </a>
                </div>
                {/* <div className="flex flex-col items-center">
                <img src={pic3} alt="" />
              </div> */}
              </div>
            </div>
          </section>
        </section>
      </div>
    </>
  );
};

export default Ratings;
